import { TFunction } from 'i18next'

import { NavigationProgramsTabData } from '@components/hooks/useNavigationProgramsTabData'

import locales from '@src/config/locales'
import { TimedSectionLink } from '@src/types/navigation'

export enum ProgramTab {
  TOPIC,
  BUSINESS_PRIORITIES,
  CERTIFICATIONS,
}

export function getProgramsTabs(
  t: TFunction,
  locale: string,
  programsTabData: NavigationProgramsTabData
) {
  const { programs, microprograms, circles } = programsTabData

  return [
    {
      name: t('programs'),
      key: ProgramTab.TOPIC,
      sections: programs.map((program) => ({
        title: program.title[locale],
        link: locales[locale].programPathFactory(program.slug[locale].current),
        description: program.shortDescription[locale],
        durationText: program.durationText[locale],
      })) as TimedSectionLink[],
      button: {
        text: t('viewAllPrograms'),
        link: locales[locale].programsPath,
      },
    },
    {
      name: t('microprograms'),
      key: ProgramTab.BUSINESS_PRIORITIES,
      sections: microprograms.map((program) => ({
        title: program.title[locale],
        link: locales[locale].microprogramPathFactory(program.slug[locale].current),
        description: program.shortDescription[locale],
        durationText: program.durationText[locale],
      })) as TimedSectionLink[],
      button: {
        text: t('viewAllMicroprograms'),
        link: locales[locale].programsPath,
      },
    },
    {
      name: t('circlesAfiU'),
      key: ProgramTab.CERTIFICATIONS,
      sections: circles
        .filter(({ course }) => course !== null)
        .map((circle) => ({
          title: circle.title[locale] as string,
          link: circle.course?.fields[`url_${locale}`],
          description: circle.shortDescription[locale],
          durationText: circle.durationText[locale],
        })) as TimedSectionLink[],
      button: {
        text: t('viewAllCircles'),
        link: locales[locale].circlesPath,
      },
    },
  ]
}
